import { AnalyticsEventTracker } from "src/app/nutrigenic/models/analytics-event-tracker.model";

export class SelectItemEventTracker implements AnalyticsEventTracker {
  constructor(private eventName: string) {
    this.eventName = eventName;
  }

  getProcessedData(rawEventData: any) {
    if (!rawEventData) return;
    console.log(rawEventData);
    const event = {
      ecommerce: {
        //currency: 'USD',
        //value: rawEventData.price,
        item_list_name: 'Meal Plans',
        items: rawEventData.ecommerce.items
        /*items: [
          {
            item_id: rawEventData.id,
            item_name: rawEventData.title,
            //item_category: rawEventData.title,
            //price: rawEventData.price,
            //quantity: 1,
          },
        ],*/
      },
    };

    return {
      eventData: event,
    };
  }
}
